import AppImage from '@/components/ui/AppImage';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`relative w-full h-[600px] lg:h-[700px] overflow-hidden ${className}`}>
      <div className="absolute inset-0">
        <AppImage
          src="https://images.unsplash.com/photo-1519387918819-51953dc6ba35"
          alt="Students working together on hydroponic system with green lettuce plants in modern classroom setting"
          fill
          className="object-cover"
          priority />

        <div className="absolute inset-0 bg-gradient-to-r from-brand-charcoal/90 via-brand-charcoal/70 to-transparent" />
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col justify-center h-full max-w-2xl">
          <div className="inline-flex items-center px-4 py-2 bg-brand-primary/20 backdrop-blur-sm rounded-full mb-6 w-fit">
            <span className="text-sm font-header font-semibold text-brand-primary-foreground">
              Flagship Program
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-header font-bold mb-6 leading-tight text-[rgba(6,5,5,1)] text-left">Farms For Thought

          </h1>

          <p className="sm:text-xl font-body text-black mb-8 text-2xl">Farms for Thought is a scalable, multi-phase education and ag-tech initiative that integrates schools, advanced agricultural technology, and experiential learning to expand access to healthy food while building the future workforce.

Where hydroponics meets innovation. Our flagship platform transforms classrooms into next-generation agricultural and innovation development, equipping students to grow food, engineer technology, and design solutions for a more sustainable world.



          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
    </section>);

};

export default HeroSection;